<template>
  <div>
    <div align="center" v-loading="loading" 
         element-loading-text="Loading..."
         element-loading-background="rgba(0, 0, 0, 0.8)">
      <div v-if="isSubscribed">
        <img :src="VIP" alt="VIP Image">
        <h1>{{ $t('VIPMember') }}</h1>
        <p>{{ $t('ExpiresOn') }}: {{ formatDate(expirationTime) }}</p>
        <p>{{ $t('Status') }}: {{ $t('Active') }}</p>
      </div>
      <div v-else>
        <img :src="NOVIP" alt="NO VIP Image">
        <h1>{{ $t('NOVIP') }}</h1>
      </div>
      <br>
      <el-form :model="formData" ref="emailForm" :rules="rules" inline>
        <el-form-item prop="email">
          <el-input v-model="email" :placeholder="$t('EmailRequired')" type="email"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="validateAndGetData" :loading="loading">
            {{ $t('Restore') }}
          </el-button>
        </el-form-item>
      </el-form>

      <p>Copyright © emperinter</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { ElNotification } from 'element-plus';
import { config } from '@/config';
import VIP from '@/assets/vip.png';
import NOVIP from '@/assets/novip.png';

export default {
  name: 'AccountPage',
  data() {
    return {
      loading: false,
      loadingType: '',
      email: '',
      isSubscribed: false,
      expirationTime: null,
      VIP: VIP,
      NOVIP: NOVIP,
      formData: { email: '' },
      rules: {
        email: [
          { required: true, message: this.$t('EmailRequired'), trigger: 'blur' },
          { type: 'email', message: this.$t('ValidEmail'), trigger: ['blur', 'change'] }
        ]
      }
    };
  },
  watch: {
    email(newValue) {
      this.formData.email = newValue;
    }
  },
  mounted() {
    this.email = localStorage.getItem("email") || '';
    if (this.email) {
      this.getSubscriptionInfo();
    }
  },
  methods: {
    async validateAndGetData() {
      this.loading = true;
      this.loadingType = 'validating';
      try {
        await this.$refs.emailForm.validate();
        if (this.email.includes("@")) {
          if (this.email === 'emperinter#@outlook.com') {
            // 测试账户处理
            const expirationTime = new Date();
            expirationTime.setDate(expirationTime.getDate() + 365); // 给予365天权限
            
            localStorage.setItem('purchaseStatus', 'purchased');
            localStorage.setItem('expirationTime', expirationTime.toISOString());
            localStorage.setItem('email', this.email);
            
            this.expirationTime = expirationTime.toISOString();
            this.isSubscribed = true;
            
            ElNotification({
              title: this.$t("Success"),
              message: this.$t("TestAccountActivated"),
              position: 'top-left',
              type: 'success'
            });
            
            // 强制刷新页面
            window.location.reload();
          } else {
            // 正常账户处理
            this.loadingType = 'fetching';
            await this.getSubscriptionInfo();
          }
        }
      } catch (error) {
        console.error('Error occurred:', error);
        ElNotification({
          title: this.$t("Warning"),
          message: this.$t("InvalidUser"),
          position: 'top-left',
          type: 'warning'
        });
      } finally {
        this.loading = false;
        this.loadingType = '';
      }
    },

    async getSubscriptionInfo() {
      try {
        const response = await axios.get(`${config.apiUrl}/v1/subscriptions`, {
          headers: {
            'Accept': 'application/json',
            'Authorization': `Bearer ${config.apiKey}`
          },
          params: {
            filter: {
              user_email: this.email
            }
          }
        });

        const subscriptionsData = response.data.data;
        if (subscriptionsData.length > 0) {
          const activeSub = subscriptionsData.find(sub => 
            sub.attributes.status === 'active' && 
            new Date(sub.attributes.renews_at) > new Date()
          );

          if (activeSub) {
            this.isSubscribed = true;
            this.expirationTime = activeSub.attributes.renews_at;
            localStorage.setItem('email', this.email);
            localStorage.setItem('purchaseStatus', 'purchased');
            localStorage.setItem('expirationTime', this.expirationTime);
          } else {
            this.isSubscribed = false;
            ElNotification({
              title: this.$t("Info"),
              message: this.$t("NoActiveSubscription"),
              position: 'top-left',
              type: 'info'
            });
          }
        } else {
          this.isSubscribed = false;
          ElNotification({
            title: this.$t("Info"),
            message: this.$t("NoSubscriptions"),
            position: 'top-left',
            type: 'info'
          });
        }
      } catch (error) {
        console.error('Error occurred:', error);
        ElNotification({
          title: this.$t("Error"),
          message: this.$t("FetchError"),
          position: 'top-left',
          type: 'error'
        });
      }
    },

    formatDate(dateString) {
      return new Date(dateString).toLocaleString();
    }
  }
};
</script>

<style scoped>
img {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  display: block;
}

.custom-loading-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(30,30,30,0.85);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.custom-loading-text {
  color: #ffd700;
  font-size: 20px;
  font-weight: bold;
  text-shadow: 0 2px 8px #000;
  margin-top: 16px;
}

:deep(.el-loading-mask) {
  background: rgba(30, 30, 30, 0.85) !important;
  backdrop-filter: blur(2px);
}

:deep(.el-loading-spinner) {
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  padding: 32px 48px;
  background: rgba(0,0,0,0.5);
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
  align-items: center;
}

:deep(.el-loading-spinner i) {
  color: #ffd700;
  font-size: 40px;
  margin-bottom: 12px;
  animation: loading-rotate 1s linear infinite;
}

:deep(.el-loading-text) {
  color: #ffd700;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 2px;
  text-shadow: 0 2px 8px #000;
}

@keyframes loading-rotate {
  100% {
    transform: rotate(360deg);
  }
}
</style>